import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Tooltip } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './styles';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Folder from '../../../../Assets/Folder.png'
const ITEMS_PER_PAGE = 20;
const FolderContainer: React.FunctionComponent<any> = ({ cardData, onFolderClick }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  console.log(paginatedData, 'cardDatassssss');

  useEffect(() => {
    if (cardData?.length) {
      const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
      const endIndex = startIndex + ITEMS_PER_PAGE;
      setPaginatedData(cardData.slice(startIndex, endIndex));
      setTotalPages(Math.ceil(cardData.length / ITEMS_PER_PAGE));
    } else {
      setPaginatedData([]);
      setTotalPages(1);
    }
  }, [cardData, currentPage]);
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.networkCardContainer}>
      <Box width="100%">
        <Paper className={classes.cardHolder}>
          <Grid container spacing={1}>
            {paginatedData.map((item) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                <Paper
                  elevation={2}
                  sx={{ borderRadius: 3, padding: 2, backgroundColor: "#F6F8FB", border: "none", boxShadow: "none", cursor: "pointer" }}
                  onClick={() => onFolderClick && onFolderClick(item.id)}
                >
                  {/* Folder Info */}
                  <Box display="flex" alignItems="center" mb={0.5}>
                    <Typography fontWeight={500} color={"#373A45"} fontSize={14}>{item.title}</Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mb={1}>
                    <Typography fontWeight={400} color={"#373A45"} fontSize={14}>Last updated on:{item?.Lastupdated}</Typography>
                  </Box>
                  {/* Folder Image */}
                  <Box
                    sx={{ width: '100%', height: 180, objectFit: 'cover', borderRadius: 2, mb: 1.5, backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center" }}
                  >
                    <img src={Folder} alt='' height={"80px"} width={"80px"} />
                  </Box>
                  {/* Collaborators */}
                  <Box display="flex" alignItems="center" gap={2} mt={1}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Typography fontSize={14} fontWeight={400} color={"#373A45"}><GroupOutlinedIcon />{item.collaborators} files</Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
          {/* Pagination */}
          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              siblingCount={2}
              boundaryCount={1}

              sx={{
                '& .MuiPaginationItem-root': {
                  borderRadius: '8px',
                  fontWeight: 400,
                  color: '#000',
                  border: '1px solid #E0E0E0',
                  '&:hover': {
                    backgroundColor: '#F5F5F5',
                  },
                },
                '& .MuiPaginationItem-page.Mui-selected': {
                  backgroundColor: '#123A6F', // deep blue background
                  color: '#fff',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: '#123A6F',
                  },
                },
                '& .MuiPaginationItem-ellipsis': {
                  color: '#000',
                },
                '& .MuiPaginationItem-previousNext': {
                  fontWeight: 400,
                  color: '#000',
                },
                '& .MuiPaginationItem-previousNext.Mui-disabled': {
                  color: '#C0C0C0',
                },
              }}
              showFirstButton={false}
              showLastButton={false}
            />
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default FolderContainer;
